<template>
  <div class="pages">
    <navTop></navTop>
    <div class="box">
      <li>
        <span>1、船头船尾</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lycttw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lycttw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>2、吃水</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lycstw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lycstw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>3、左右倾斜</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyqxtw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lyqxtw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 1 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc1sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.lyc1sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid #1ba8e8; width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px; box-shadow: 0 0 20px rgba(27,168,232,0.4); cursor: pointer;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 1 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc1tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lyc1tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 2 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc2sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.lyc2sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid #1ba8e8; width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px; box-shadow: 0 0 20px rgba(27,168,232,0.4); cursor: pointer;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 2 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc2tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lyc2tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 3 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc3sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.lyc3sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid #1ba8e8; width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px; box-shadow: 0 0 20px rgba(27,168,232,0.4); cursor: pointer;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 3 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc3tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lyc3tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 4 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc4sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.lyc4sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid #1ba8e8; width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px; box-shadow: 0 0 20px rgba(27,168,232,0.4); cursor: pointer;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 4 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc4tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lyc4tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 5 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc5sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.lyc5sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid #1ba8e8; width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px; box-shadow: 0 0 20px rgba(27,168,232,0.4); cursor: pointer;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 5 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc5tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lyc5tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 6 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc6sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.lyc6sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid #1ba8e8; width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px; box-shadow: 0 0 20px rgba(27,168,232,0.4); cursor: pointer;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 6 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc6tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lyc6tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>舱 7 (视频)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc7sw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" :key="index" v-for="(item, index) in dataList.lyc7sw.split('|').map(str => JSON.parse(str))">
            <video :src="item.image" @click="togglePlayback(item.image)"
                   width="100px" height="50px"
                   style="border-radius: 10px;border: 1px solid #1ba8e8; width: 392px;height: 292px;margin-right: 50px;margin-bottom: 20px; box-shadow: 0 0 20px rgba(27,168,232,0.4); cursor: pointer;" />
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>
      <li>
        <span>舱 7 (图片)</span>
        <div style="margin-top: 15px;display: flex;flex-wrap: wrap;" v-if="dataList.lyc7tw">
          <div style="display: flex;flex-direction: column;margin-bottom: 20px" v-for="(item,index) in dataList.lyc7tw.split('|').map(str => JSON.parse(str))">
            <img style="display: block;width: 392px;height: 292px;border-radius: 10px;margin-right: 50px;margin-bottom: 20px;" :src="item.image">
            <div style="color:#ffffff;width: 392px;text-overflow: ellipsis;overflow: hidden;">{{item.text}}</div>
          </div>
        </div>
      </li>

      <li>
        <span>8. (H.S.F.O）</span>
        <span>{{dataList.lyhs01}}</span>
        <span style="color: #c0e4ff">{{dataList.lyhs02}}</span>
      </li>

      <li>
        <span>9.（L.S.F.O）</span>
        <span>{{dataList.lyls01}}</span>
        <span style="color: #c0e4ff">{{dataList.lyls02}}</span>
      </li>

      <li>
        <span>10.（M.D.O）</span>
        <span>{{dataList.lymd01}}</span>
        <span style="color: #c0e4ff">{{dataList.lymd02}}</span>
      </li>

      <li>
        <span>11.（M.G.O）</span>
        <span>{{dataList.lymg01}}</span>
        <span style="color: #c0e4ff">{{dataList.lymg02}}</span>
      </li>
    </div>

    <navFooter></navFooter>

    <el-dialog
        title="视频"
        size="small"
        v-dialogDrag
        :visible.sync="isVisible"
        :before-close="handleClose">
      <div class="video-player">
        <!-- 视频元素 -->
        <video
            ref="videoPlayer"
            :src="videoSrc"
            style="width: 100%;height: auto;display: block;"
            @timeupdate="updateProgress"
            @play="onPlay"
            @pause="onPause"
            @loadedmetadata="onLoadedMetadata"/>

        <!-- 控制栏 -->
        <div class="controls">
          <!-- 播放/暂停按钮 -->
          <button @click="togglePlayPause" class="control-btn">
            <img v-if="!isPlaying" src="../../assets/stop_icon.png" style="width: 30px;height: 30px; filter: drop-shadow(0 0 8px #1ba8e8);"/>
            <img v-if="isPlaying" src="../../assets/start_icon.png" style="width: 30px;height: 30px; filter: drop-shadow(0 0 8px #1ba8e8);"/>
          </button>

          <!-- 进度条 -->
          <div class="progress-bar" @click="seekToTime">
            <div class="progress" :style="{ width: progress + '%' }"></div>
          </div>

          <!-- 时间显示 -->
          <span class="time">{{ currentTime }} / {{ duration }}</span>

          <!-- 全屏按钮 -->
          <button @click="toggleFullScreen" class="control-btn">
            <i class="fas fa-expand" style="color: #1ba8e8;"></i>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';
import pdf from 'vue-pdf';
export default {
  name: 'newLy',
  components: {
    navTop,
    navFooter,
    pdf
  },
  data() {
    return {
      dataList: {},
      num: '',
      isVisible: false, // 控制播放状态

      videoSrc: '', // 视频URL
      isPlaying: false, // 是否正在播放
      progress: 0, // 播放进度
      currentTime: '00:00', // 当前播放时间
      duration: '00:00', // 视频总时长
      videoList:[]
    };
  },
  created() {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({ path: '/' });
    } else {
      this.id = this.$route.query.id;
      this.getSchedulely();
    }
  },
  methods: {
    getSchedulely() {
      let data = {
        id: this.id
      };
      this.$api.schedulely(data).then(res => {
        if (res.result == 0) {
          this.dataList = res.data;
          let list=this.dataList.lycttw ? this.dataList.lycttw.split('|') : [];
          console.log("list====>",list)
          let jsonDataList = this.dataList.lycttw ? this.dataList.lycttw.split('|').map(str => JSON.parse(str)) : [];
          console.log("jsonDataList====>",jsonDataList)
          // if (res.data.ly026) {
          // 	if (this.getSuffix(res.data.ly026) == 'pdf') {
          // 		this.num = 1;
          // 	} else {
          // 		this.num = 0;
          // 	}
          // }


        }
      });
    },

    getLyVideo(){
      this.$http({
        url: `/at/order/atOrder/getLyDetail?id=${this.inputForm.id}`,
        method: 'get'
      }).then(({data}) => {
        if(data.lyDetail){
          data.lyDetail.split('|').forEach((item) => {
            if (item.trim().length > 0) {
              this.videoList.push(item);
            }
          })
        }
      })
    },
    getJyVideo(){
      this.$http({
        url: `/at/order/atOrder/getJyDetail?id=${this.inputForm.id}`,
        method: 'get'
      }).then(({data}) => {
        if(data.jyDetail){
          data.jyDetail.split('|').forEach((item) => {
            if (item.trim().length > 0) {
              this.videoList.push(item);
            }
          })
        }
      })
    },
    // 截取后缀名
    getSuffix(str) {
      var index = str.lastIndexOf('.');
      return str.substr(index + 1);
    },
    togglePlayback(item){
      this.videoSrc=item
      this.isVisible=true
    },

    // 切换播放/暂停
    togglePlayPause() {
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },

    // 更新播放进度
    updateProgress() {
      const video = this.$refs.videoPlayer;
      this.progress = (video.currentTime / video.duration) * 100; // 计算进度百分比
      this.currentTime = this.formatTime(video.currentTime); // 格式化当前时间
    },

    // 跳转到指定时间
    seekToTime(event) {
      const video = this.$refs.videoPlayer;
      const progressBar = event.currentTarget;
      const clickPosition = event.offsetX; // 获取点击位置
      const progressBarWidth = progressBar.clientWidth; // 获取进度条宽度
      const seekTime = (clickPosition / progressBarWidth) * video.duration; // 计算跳转时间
      video.currentTime = seekTime;
    },

    // 播放事件
    onPlay() {
      this.isPlaying = true;
    },

    // 暂停事件
    onPause() {
      this.isPlaying = false;
    },

    // 视频元数据加载完成
    onLoadedMetadata() {
      const video = this.$refs.videoPlayer;
      this.duration = this.formatTime(video.duration); // 初始化总时长
    },

    // 切换全屏
    toggleFullScreen() {
      const video = this.$refs.videoPlayer;
      if (!document.fullscreenElement) {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },

    // 格式化时间（秒 -> MM:SS）
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    handleClose(){
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
      this.isVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    max-width: 1400px;
    margin: 30px auto 80px;
    padding: 0 20px;
    position: relative;
    z-index: 2;

    border: 1px solid $blue-primary-rgba;
    border-radius: 20px;
    padding: 40px 60px;
    box-sizing: border-box;
    background: rgba(15, 43, 63, 0.6);
    backdrop-filter: blur(10px);
    box-shadow: 0 0 40px $blue-glow;

    li {
      display: flex;
      flex-direction: column;
      padding-bottom: 30px;
      margin-bottom: 20px;
      border-bottom: 1px dashed $blue-primary-rgba;
      box-sizing: border-box;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
        margin-bottom: 0;
      }

      span:nth-child(1) {
        color: $blue-primary;
        font-size: 20px;
        line-height: 1.2em;
        font-weight: 500;
        text-shadow: $text-glow;
      }

      span:nth-child(2) {
        font-size: 18px;
        color: #c0e4ff;
        line-height: 1.3em;
        padding-top: 10px;
        box-sizing: border-box;
        word-break: break-word;
      }

      a {
        font-size: 18px;
        color: #c0e4ff;
        line-height: 1.3em;
        padding-top: 10px;
        box-sizing: border-box;
        word-break: break-word;
        text-decoration: none;
        transition: all 0.3s ease;

        &:hover {
          color: $blue-primary;
          text-shadow: $text-glow;
        }
      }

      img {
        margin-top: 15px;
        display: block;
        width: 100%;
        max-width: 392px;
        height: auto;
        max-height: 292px;
        border-radius: 10px;
        border: 2px solid $blue-primary;
        box-shadow: 0 0 20px $blue-glow;
        object-fit: cover;
      }

      div[style*="display: flex;flex-wrap: wrap;"] {
        div[style*="display: flex;flex-direction: column;"] {
          margin-right: 30px;

          img, video {
            border: 2px solid $blue-primary;
            box-shadow: 0 0 20px $blue-glow;
            transition: all 0.3s ease;

            &:hover {
              transform: scale(1.02);
              box-shadow: 0 0 30px $blue-primary;
            }
          }

          div[style*="color:#ffffff"] {
            color: #c0e4ff !important;
            font-size: 14px;
            line-height: 1.4;
            margin-top: 5px;
          }
        }
      }
    }
  }
}

.video-player {
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  background: #000;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid $blue-primary;
  box-shadow: 0 0 30px $blue-glow;
}

.controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(15, 43, 63, 0.9);
  backdrop-filter: blur(5px);
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-top: 1px solid $blue-primary-rgba;
}

.control-btn {
  background: none;
  border: none;
  color: $blue-primary;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    text-shadow: $text-glow;
  }
}

.progress-bar {
  flex: 1;
  height: 5px;
  background: rgba(27, 168, 232, 0.2);
  position: relative;
  cursor: pointer;
  border-radius: 3px;
  overflow: hidden;
}

.progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: $blue-primary;
  box-shadow: 0 0 10px $blue-primary;
}

.time {
  color: #c0e4ff;
  font-size: 14px;
  text-shadow: 0 0 5px $blue-glow;
}

::v-deep .el-dialog {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  border: 1px solid $blue-primary;
  border-radius: 10px;
  box-shadow: 0 0 40px $blue-glow;

  .el-dialog__title {
    color: $blue-primary;
    text-shadow: $text-glow;
  }

  .el-dialog__header {
    border-bottom: 1px solid $blue-primary-rgba;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: $blue-primary;

    &:hover {
      color: lighten($blue-primary, 20%);
    }
  }

  .el-dialog__body {
    padding: 20px;
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      padding: 30px 40px;

      li {
        span:nth-child(1) {
          font-size: 18px;
        }

        span:nth-child(2) {
          font-size: 16px;
        }

        div[style*="display: flex;flex-wrap: wrap;"] {
          div[style*="display: flex;flex-direction: column;"] {
            img, video {
              width: 300px;
              height: 220px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      padding: 20px;

      li {
        span:nth-child(1) {
          font-size: 16px;
        }

        span:nth-child(2) {
          font-size: 14px;
        }

        div[style*="display: flex;flex-wrap: wrap;"] {
          div[style*="display: flex;flex-direction: column;"] {
            width: 100%;
            margin-right: 0;

            img, video {
              width: 100%;
              height: auto;
              max-height: 250px;
              margin-right: 0;
            }

            div[style*="color:#ffffff"] {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>